import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input
}                         from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CompanyService }    from './company.service';
import { FlipperSidesModel } from '../shared/components/flipper/typings/flipper.sides';
import { MessagesService }   from '../messages/messages.service';

@Component({
  selector   : 'wor-share-accounting',
  template: require('./company.share-accounting.component.html')
})
export class ShareAccoutingComponent {
  public activeSide: FlipperSidesModel = 'front';
  public prefix    : string;

  @Input() integration : string;

  constructor (
    public activeModal       : NgbActiveModal,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(forwardRef(() => CompanyService))
    private companyService   : CompanyService,
    @Inject(forwardRef(() => MessagesService)) private messagesService  : MessagesService
  ) {}

  confirmPrefix () : void {
    this.companyService.confirmAccountSharingPrefix(this.prefix)
    .then(() => {
      this.activeModal.close();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  confirmSharing () : void {
    this.companyService.confirmAccountSharing()
    .then(() => this.flip())
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  flip ( side : FlipperSidesModel = 'back' ) : void {
    this.activeSide = side

    this.changeDetectorRef.detectChanges();
  }
}
